module.exports = __webpack_public_path__ + "static/img/nanjyy.da54a0b2.png";